import { FC, useState, useCallback, ChangeEvent, useEffect } from "react";
import { Button } from "@funded-here-interface/common";
import { useStyles } from "./Notes.styles";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";

interface IProps {
  initialNote?: string;
  userId: number | null;
  type?: "regular" | "spv";
}

const Note: FC<IProps> = ({ initialNote = "", userId, type = "regular" }) => {
  const { classes } = useStyles();
  const [note, setNote] = useState(initialNote);
  const [savedNote, setSavedNote] = useState(initialNote);

  const handleSave = useCallback(async () => {
    if (!note.trim() || !userId) return;
    try {
      await axios.post(
        `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/organization/remark/${userId}?type=${type}`,
        { note, type },
      );
      const response = await axios.get(
        `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/organization/remark/${userId}?type=${type}`,
      );
      const latestNote = response.data.note || "";
      setNote(latestNote);
      setSavedNote(latestNote);
      toast.success("Remark saved successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (error) {
      toast.error("Failed to save remark. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  }, [note, userId, type]);

  useEffect(() => {
    const fetchLatestNote = async () => {
      try {
        if (!userId) {
          setNote(initialNote);
          setSavedNote(initialNote);
          return;
        }
        const response = await axios.get(
          `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/organization/remark/${userId}?type=${type}`,
        );
        const latestNote = response.data.note || initialNote;
        setNote(latestNote);
        setSavedNote(latestNote);
      } catch (error) {
        setNote(initialNote || "Error loading note");
        setSavedNote(initialNote || "Error loading note");
        toast.error("Failed to load note. Please try again.", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    };

    fetchLatestNote();
  }, [userId, initialNote, type]);

  const handleChange = useCallback((e: ChangeEvent<HTMLTextAreaElement>) => {
    const value = e?.target?.value ?? "";
    setNote(value);
  }, []);

  const isSaveDisabled = !note.trim() || note === savedNote;

  return (
    <div className={classes.noteContainer}>
      <div className={classes.inputGroup}>
        <textarea
          id="note_input"
          value={note || ""}
          onChange={handleChange}
          placeholder="Enter your remarks here"
          rows={4}
          className={classes.textarea}
        />
      </div>
      <div className={classes.buttonContainer}>
        <Button
          onClick={handleSave}
          disabled={isSaveDisabled}
          textColor="white"
          backgroundColor="rgb(55, 134, 214)"
        >
          Save Remark
        </Button>
      </div>
    </div>
  );
};

export default Note;
